<template>
  <div class="header-actions">
    <button
      class="expandAction"
      @click="show = !show"
    ><ion-icon name="ellipsis-vertical-outline"></ion-icon></button>

    <div class="actions" :class="{ '-show': show }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderActions',

  data() {
    return {
      show: false,
    };
  },

  methods: {
    /**
     * Check if element are inside a header-actions component.
     *
     * @param el
     * @returns {boolean}
     */
    elementAreInsideHeaderActions(el) {
      try {
        let node = el.parentNode;

        while (node != null) {
          if ((node.className || '').indexOf('header-actions') > -1) {
            return true;
          }

          node = node.parentNode;
        }

        return false;
      } catch {
        return false;
      }
    },
  },

  mounted() {
    document.addEventListener('click', ({ target }) => {
      const elementAreInsideHeaderActions = this.elementAreInsideHeaderActions(target);

      if (this.show && !elementAreInsideHeaderActions) {
        this.show = false;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
  .header-actions {
    @apply flex;
    @apply items-center;

    > .expandAction {
      @apply flex;
      @apply text-xl;
      outline: none;

      @screen md {
        display: none;
      }
    }

    > .actions {
      width: 100%;
      position: absolute;
      z-index: 12;
      top: 100%;
      right: 0;
      background: #fff;
      box-shadow: 0px 3px 6px rgba(89, 102, 122, 0.3);
      border-color: #e2e8f0;
      box-sizing: border-box;
      display: none;
      border-radius: 4px;
      flex-wrap: wrap;
      padding: 10px;

      &.-show {
        @apply flex;
      }

      @screen md {
        @apply flex;
        position: initial;
        background: transparent;
        box-shadow: none;
      }
    }
}
</style>
